import { gql } from '@apollo/client';

export const ADD_FAVORITE = gql`
  mutation AddFavorite($input: FavoriteInput!) {
    addFavorite(input: $input) {
      itemDetails {
        ... on Place {
          name
          address
          website
        }
        ... on PSA {
          description
          title
        }
        ... on LostAnimal {
          animalName
        }
        ... on FoundAnimal {
          animalName
        }
      }
    }
  }
`;

export const REMOVE_FAVORITE = gql`
  mutation RemoveFavorite($itemId: String!) {
    removeFavorite(itemId: $itemId) {
      id
      itemId
      itemType
      itemDetails {
        ... on Place {
          name
          address
          website
        }
        ... on PSA {
          title
          description
        }
        ... on LostAnimal {
          animalName
        }
        ... on FoundAnimal {
          animalName
        }
      }
    }
  }
`;